import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { routerReducer } from "@ngrx/router-store";
import { ActionReducerMap } from "@ngrx/store";
import { contractEsReducers } from "./contract-es.reducers";
import { OrderEsReducers } from "./order-es.reducers";
import { SolarAccountEsReducers } from "./solar-account-es.reducers";
import { RequestsOperationsESReducers } from "./request-operations-es.reducers";
import { DocumentEsReducers } from "./document-es.reducers";
import { ProductEsReducers } from "./product-es.reducer";
import { fileUploadReducersES } from "./file-upload-es.reducers";

export const appEsReducers: ActionReducerMap<IAppEsState, any> = {
    router: routerReducer,
    contractsEs: contractEsReducers,
    orderEs: OrderEsReducers,
    solarAccountEs: SolarAccountEsReducers,
    requestOperationsEs: RequestsOperationsESReducers,
    document: DocumentEsReducers,
    productEs: ProductEsReducers,
    uploadedFileEs: fileUploadReducersES,

};
